import { defineStore } from 'pinia'
import { computed, reactive, ref } from 'vue'
import { STACKING_SETS, StackingSet, StackingSetKey } from '@/data/stacking'
import { addThousandSeparator, isAsciiOrExtended } from '@/utils'
import all from '@/data/all'

const pickAndFormatStackings = (stackingSet: StackingSet) => {
  return stackingSet.stackings.map(stacking => {
    return {
      ...stacking,
      titleString: stacking.title.join(''),
      title: stacking.title.map(text => ({
        text,
        isAsciiOrExtended: isAsciiOrExtended(text)
      })),
      products: stacking.products.map(product => {
        const current = all.find(item => item.skuId === product.skuId)
        return {
          ...product,
          title: product.name.map(text => ({
            text,
            isAsciiOrExtended: isAsciiOrExtended(text)
          })),
          price: current?.price || 0,
          priceString: `¥${addThousandSeparator(current?.price || 0)}`
        }
      })
    }
  })
}
export type FormattedStackings = ReturnType<typeof pickAndFormatStackings>
export type FormattedStacking = ReturnType<
  typeof pickAndFormatStackings
>[number]

export const useStackingStore = defineStore('stacking', () => {
  const stackingsMap = reactive<Record<string, FormattedStackings>>({})
  const selectedStackingSetKey = ref<keyof typeof STACKING_SETS>()
  const selectedStacking = ref<FormattedStacking>()

  const initStackingsAndProducts = () => {
    Object.values(STACKING_SETS).forEach(stackingSet => {
      stackingsMap[stackingSet.key] = pickAndFormatStackings(stackingSet)
    })
  }

  const setSelectedStackingSetByKey = (key: StackingSetKey) => {
    // console.log(
    //   '[[ Selection ] try to select stacking set ]',
    //   { key, hasKey: Object.hasOwn(STACKING_SETS, key) },
    //   Date.now()
    // )
    if (
      Object.hasOwn(STACKING_SETS, key) &&
      selectedStackingSetKey.value !== key
    ) {
      console.log(
        '[[ Selection ] Set Selected Stacking Set ]',
        { key },
        Date.now()
      )
      selectedStackingSetKey.value = key
      return true
    }
    return false
  }

  const selectedStackingSet = computed(() =>
    selectedStackingSetKey.value
      ? STACKING_SETS[selectedStackingSetKey.value]
      : undefined
  )

  const selectedStackings = computed(() =>
    selectedStackingSetKey.value
      ? stackingsMap[selectedStackingSetKey.value]
      : []
  )

  const setSelectedStacking = (stacking: FormattedStacking) => {
    // console.log(
    //   '[[ Selection ] try to select stacking ]',
    //   { guid: stacking?.guid },
    //   Date.now()
    // )
    if (stacking?.guid !== selectedStacking.value?.guid) {
      console.log(
        '[[ Selection ] Set Selected Stacking ]',
        { guid: stacking.guid },
        Date.now()
      )
      selectedStacking.value = stacking
      return true
    }
    return false
  }

  const reset = () => {
    // console.log('[[ Selection ] try to reset stacking store ]', Date.now())
    let changed = false
    if (selectedStackingSetKey.value !== undefined) {
      console.log(
        '[[ Selection ] Reset StackingStore / StackingSet ]',
        Date.now()
      )
      selectedStackingSetKey.value = undefined
      changed = true
    }
    if (selectedStacking.value !== undefined) {
      console.log('[[ Selection ] Reset StackingStore / Stacking ]', Date.now())
      selectedStacking.value = undefined
      changed = true
    }
    return changed
  }

  return {
    selectedStackingSet,
    selectedStacking,
    selectedStackings,
    initStackingsAndProducts,
    setSelectedStackingSetByKey,
    setSelectedStacking,
    reset
  }
})
